// extracted by mini-css-extract-plugin
module.exports = {"frame":"KnowledgeBaseVideoLibrary_frame__kX0zx"};